import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import type { TopicCombination } from '../models';

interface QuestionsApiResponse {
  combinations: TopicCombination[];
}

@Injectable({ providedIn: 'root' })
export class TopicCombinationService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/questions`;

  async getCombination(
    year: number,
    month: number,
    combinationNumber?: number
  ): Promise<TopicCombination | null> {
    const yearmonth = `${year}-${month.toString().padStart(2, '0')}`;

    try {
      const res = await this.http
        .get<QuestionsApiResponse>(`${this.apiUrl}`, { params: { yearmonth } })
        .toPromise();

      const combinations = res?.combinations ?? [];
      if (combinations.length === 0) return null;

      if (combinationNumber != null) {
        const match = combinations.find((c) => c.combinationNumber === combinationNumber);
        return match ?? combinations[0] ?? null;
      }
      return combinations[0] ?? null;
    } catch {
      return null;
    }
  }

  async getCombinations(year: number, month: number): Promise<TopicCombination[]> {
    const yearmonth = `${year}-${month.toString().padStart(2, '0')}`;

    try {
      const res = await this.http
        .get<QuestionsApiResponse>(`${this.apiUrl}`, { params: { yearmonth } })
        .toPromise();
      return res?.combinations ?? [];
    } catch {
      return [];
    }
  }
}
